import type { WorklogEvent } from './types';

export type CorrectionIndex = Map<number, WorklogEvent>;

export function buildCorrectionIndex(events: WorklogEvent[]): CorrectionIndex {
  const idx: CorrectionIndex = new Map();
  for (const ev of events) {
    if (ev.event !== 'correct') continue;
    if (typeof ev.target_epoch !== 'number') continue;
    const prev = idx.get(ev.target_epoch);
    const cur = ev.ntp && ev.ntp.epoch;
    if (!prev || (cur && cur > ((prev.ntp && prev.ntp.epoch) || 0))) {
      idx.set(ev.target_epoch, ev);
    }
  }
  return idx;
}

export function correctionFor(index: CorrectionIndex, epoch: number | undefined): WorklogEvent | null {
  if (!epoch) return null;
  return index.get(epoch) ?? null;
}
